require('./passCode.scss');
// @ vendors
const React = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
// @ components
const { InputText } = require('components/inputText/inputText');
//@utilities
import { formatText } from 'core/i18n';
// @ actions
const formActions = require('react-redux-form').actions;
const stepsActions = require('actions/stepsActions');

class PassCode extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            success: false,
            disabled: false,
            error: false,
            array: [],
        };

        this.handleValidatePositions = this.handleValidatePositions.bind(this);
        this.getIndexPosition = this.getIndexPosition.bind(this);
        this.positionSubtitle = this.positionSubtitle.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    getIndexPosition(index) {
        const { positions } = this.props;
        let res = -9;
        const positionsArray = positions.split(' ').map(Number);
        for (let i = 0; i < positionsArray.length; i++) {
            if (index == positionsArray[i]) {
                res = positionsArray[i];
            }
        }
        return res;
    }

    handleValidatePositions() {
        const { positions, actions, operationType, userProfile } = this.props;
        const accessToken = userProfile.accessToken;

        let array = [];
        const positionsArray = positions.split(' ').map(Number);
        for (let i = 0; i < positionsArray.length; i++) {
            let val = document.getElementById('position_' + positionsArray[i]).value;
            if (val) {
                array.push(val);
            }
        }

        let values = array.join(' ');
        actions.verifyPositions(operationType, values, accessToken, (res, data) => {
            if (res) {
                if (!data.allVerificationDone && data.otpChallenge) {
                    this.props.showOTP();
                    this.setState({
                        success: true,
                        count: 0,
                        disabled: true,
                        error: false,
                    });
                }
            } else {
                if (!this.state.success) {
                    this.setState({
                        error: true,
                    });
                }
            }
        });
    }

    positionSubtitle() {
        const { positions } = this.props;
        const positionsArray = positions.split(' ').map(Number);
        let string =
            positionsArray[0] + ', ' + positionsArray[1] + ', ' + positionsArray[2] + ' y ' + positionsArray[3];
        return string;
    }

    handleOnChange(e) {
        let value = e.target.value;
        if (value !== '') {
            this.setState({
                count: this.state.count + 1,
            });
        } else {
            this.setState({
                count: this.state.count - 1,
            });
        }
    }

    render() {
        const { userProfile, userProfileForm, positions, keySize, formActions } = this.props;
        const btClass = this.state.count >= 4 ? 'signature-passcode__button' : 'signature-passcode__button__hidden';
        const iconClass = this.state.success
            ? 'signature-passcode__button icons--icon-check'
            : 'signature-passcode__icon-hidden';
        const errorClass = this.state.error ? 'pass-code-input__error' : 'pass-code-input__error-hidden';

        let inputs = [];
        let numbers = [];
        const positionsSubtitule = this.positionSubtitle();

        if (positions) {
            for (let index = 1; index <= keySize; index++) {
                const numberId = 'inputPosition_' + index;
                let position = this.getIndexPosition(index);
                if (index === position) {
                    inputs.push(
                        <div className="signature-passcode__box">
                            <InputText
                                profileModel={'userProfile.position_' + index}
                                type="password"
                                id={'position_' + index}
                                inputClass="pass-code__input"
                                name={'position_' + index}
                                placeholder="#"
                                autoComplete="off"
                                maxLength="1"
                                onChange={this.handleOnChange}
                                disabled={this.state.disabled}
                                userProfileForm={userProfileForm}
                                userProfile={userProfile}
                                formActions={formActions}
                                {...this.props}
                            />
                        </div>
                    );

                    numbers.push(
                        <div key={index} className="signature-passcode__box">
                            <span id={numberId}>{index}</span>
                        </div>
                    );
                } else {
                    const id = 'divPosition_' + index;
                    inputs.push(
                        <div key={index} className="signature-passcode__box signature-passcode__box--empty">
                            <span id={id}>*</span>
                        </div>
                    );
                    numbers.push(
                        <div key={index} className="signature-passcode__box signature-passcode__box--number">
                            <span id={numberId}>{index}</span>
                        </div>
                    );
                }
            }
        }

        return (
            <div>
                <div className="form__input">
                    <label className="top-label">{formatText('otp-confirmationCode')}</label>
                    <br />
                    <label className="sub-label">
                        {formatText('changeData-subLabel') + positionsSubtitule + formatText('changeData-subLabel2')}
                    </label>
                </div>
                <div className="signature-passcode__container">
                    <br />
                    <div className="signature-passcode__boxes">{inputs}</div>
                    <div>{numbers}</div>
                </div>
                <span className={iconClass}></span>
                <div className={btClass}>
                    <button
                        onClick={this.handleValidatePositions}
                        type="button"
                        className="form__button form__button-primaryB"
                    >
                        {formatText('button-validate')}
                    </button>
                </div>
                <div className={errorClass}>
                    <span>{formatText('changeData-passCodeIncorrect')}</span>
                </div>
            </div>
        );
    }
}

module.exports.PassCode = connect(
    state => ({
        userProfile: state.userProfile,
        extraData: state.extraData,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        options: state.options,
        focus: state.focus,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
    })
)(PassCode);
